
// import React, { useState, useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import AddUser from "./AddUser";
// import UserList from "./UserList";
// import UserPermissions from "./UserPermissions";
// import UserActivityLogs from "./UserActivityLogs";
// import Navigationbar from '../Navigationbar';


// const UserAccounts = () => {
//   const location = useLocation();
//   const [activeSubTab, setActiveSubTab] = useState("Add User"); // Default subtab

//   // Set the subtab based on passed state from Link
//   useEffect(() => {
//     if (location.state?.activeSubTab) {
//       setActiveSubTab(location.state.activeSubTab);
//     }
//   }, [location.state]);

//   const renderSubTabContent = () => {
//     switch (activeSubTab) {
//       case "Add User":
//         return <AddUser />;
//       case "User List":
//         return <UserList />;
//       case "User Permissions":
//         return <UserPermissions />;
//       case "User Activity":
//         return <UserActivityLogs />;
//       default:
//         return null;
//     }
//   };

//   return (
//     <div style={{height:'100vh', overflow:'hidden'}}>
//     {/* Navigation Bar */}
//     <Navigationbar />
//     <div>
//       <div className="sub-navbar">
//         <ul className="menu">
//           {["Add User", "User List", "User Permissions", "User Activity"].map((subTab) => (
//             <li
//               key={subTab}
//               className={activeSubTab === subTab ? "active" : ""}
//               onClick={() => setActiveSubTab(subTab)}
//             >
//               {subTab}
//             </li>
//           ))}
//         </ul>
//       </div>
//       <div className="sub-tab-content">{renderSubTabContent()}</div>
//     </div>
    
//     </div>
//   );
// };

// export default UserAccounts;


import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Tabs, Tab, Box, Typography } from "@mui/material";
import AddUser from "./AddUser";
import UserList from "./UserList";
import UserPermissions from "./UserPermissions";
import UserActivityLogs from "./UserActivityLogs";
import Navigationbar from "../Navigationbar";

const UserAccounts = () => {
  const location = useLocation();
  const [activeSubTab, setActiveSubTab] = useState(0); // Default to first tab

  const subTabs = [
    { label: "Add User", content: <AddUser /> },
    { label: "User List", content: <UserList /> },
    { label: "User Permissions", content: <UserPermissions /> },
    { label: "User Activity", content: <UserActivityLogs /> },
  ];

  // Set the subtab based on passed state from Link
  useEffect(() => {
    if (location.state?.activeSubTab) {
      const tabIndex = subTabs.findIndex(tab => tab.label === location.state.activeSubTab);
      if (tabIndex !== -1) setActiveSubTab(tabIndex);
    }
  }, [location.state]);

  return (
    <div style={{ height: "100vh", overflow: "hidden" }}>
      {/* Navigation Bar */}
      <Navigationbar />
      <div style={{ marginLeft: "8.5%" }}>
        {/* Subtabs */}
        <Box sx={{ borderBottom: 1, borderColor: "divider", mt: 1, ml: 3 }}>
          <Tabs
            value={activeSubTab}
            onChange={(e, newValue) => setActiveSubTab(newValue)}
            textColor="primary"
            indicatorColor="primary"
          >
            {subTabs.map((tab, index) => (
              <Tab key={index} label={tab.label} 
              sx={{
                "&.Mui-selected": {
                  backgroundColor: "#d1e8ff",
                  fontWeight: 550,
                },
              }}
              />
            ))}
          </Tabs>
        </Box>

        {/* Tab Content */}
        <Box sx={{ p: 0.5 }}>
          <Typography component="div">
            {subTabs[activeSubTab].content}
          </Typography>
        </Box>
      </div>
    </div>
  );
};

export default UserAccounts;

